import { Box } from "@mui/material"
import { useCurrentUser } from "../../hooks/contexts/currentUserContext"
import TextParagraph from "../../assets/components/TextParagraph"
import RouteButton from "../../assets/components/RouteButton"
import { ROUTES } from "../../utils/api"
import { AddLinkOutlined, ShortcutOutlined } from "@mui/icons-material"
import ChangePassword from "../../components/ChangePassword"
import BasicAccordion from "../../assets/components/BasicAccordion"

import { useContext } from "react"
import { PolyglotContext } from "../../polyglot/polyGlotContext"
import LanguageSelect from "../../polyglot/LanguageSelect"

const Account = () => {
    const { polyglot } = useContext(PolyglotContext)

    const currentUser = useCurrentUser()

    return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "20px" }}>
            <TextParagraph heading={polyglot.t("settings.account.headingEmail")} body={currentUser?.auth.email} />

            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "8px" }}>
                <TextParagraph heading={polyglot.t("settings.account.headingPassword")} />
                <BasicAccordion summary={<TextParagraph body={polyglot.t("settings.account.accordionPassword")} />} details={<ChangePassword />} />
            </Box>

            {currentUser?.customer ? (
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "8px" }}>
                    <TextParagraph heading={polyglot.t("settings.account.headingLicense")} />
                    <RouteButton title={currentUser.customer.alias} route={ROUTES.SETTINGS.LICENSE.fullPath} icon={ShortcutOutlined} />
                </Box>
            ) : (
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "5px" }}>
                    <TextParagraph heading={polyglot.t("settings.account.headingNoLicense")} body="Ditt konto är inte kopplat till en licens ännu" />
                    <RouteButton title={polyglot.t("settings.account.")} route={ROUTES.SETTINGS.LICENSE.fullPath} icon={AddLinkOutlined} />
                </Box>
            )}
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "5px" }}>
                <TextParagraph heading={polyglot.t("settings.account.changeLanguage")} />
                <LanguageSelect />
            </Box>
        </Box >
    )
}

export default Account